import { environment } from 'src/environments/environment';

export const keycloakConfig = {
  config: environment.keycloak,
  initOptions: {
    onLoad: 'login-required' as const,
    silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
    scope: 'openid offline_access',
  },
};
